import { render, staticRenderFns } from "./basic-select.vue?vue&type=template&id=e4c1b5f4"
import script from "./basic-select.vue?vue&type=script&lang=js"
export * from "./basic-select.vue?vue&type=script&lang=js"
import style0 from "./basic-select.vue?vue&type=style&index=0&id=e4c1b5f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports